(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nh-pilot-bundle-dialog"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => root.querySelectorAll('[data-nh-bundle-host]').forEach(host => {
      if (host.dataset.initialized) return;
      host.dataset.initialized = 'true';
      const dialog = host.querySelector('dialog');
      const submit = host.querySelector('[data-nh-bundle-submit]');
      const message = host.querySelector('[data-nh-bundle-message]');
      const cartLink = host.querySelector('[data-nh-bundle-cart]');
      const items = [...host.querySelectorAll('[data-nh-bundle-product]')].map(row => ({row, id:row.dataset.id, price:Number(row.dataset.price), available:row.dataset.available === 'true', quantity:0}));
      const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency:host.dataset.currency || 'EUR'}).format(cents / 100);
      let busy = false;
      let added = false;
      let opener;
      const calculate = () => {
        const count = items.reduce((sum,item) => sum + item.quantity, 0);
        const percent = count >= 3 ? Number(host.dataset.discountThree) : count === 2 ? Number(host.dataset.discountTwo) : 0;
        const subtotal = items.reduce((sum,item) => sum + item.quantity * item.price, 0);
        const total = items.reduce((sum,item) => sum + item.quantity * (item.price - Math.floor(item.price * percent / 100)), 0);
        return {count,percent,subtotal,total};
      };
      const update = () => {
        const {count,percent,subtotal,total} = calculate();
        items.forEach(item => {
          item.row.querySelector('[data-nh-bundle-price]').textContent = money(item.price);
          item.row.querySelector('[data-nh-bundle-quantity]').textContent = item.quantity;
          item.row.querySelector('[data-nh-bundle-less]').disabled = busy || item.quantity === 0;
          item.row.querySelector('[data-nh-bundle-more]').disabled = busy || !item.available || count >= 3;
          item.row.classList.toggle('is-selected',item.quantity > 0);
        });
        host.querySelector('[data-nh-bundle-count]').textContent = host.dataset.countText.replace('__COUNT__',count);
        host.querySelector('[data-nh-bundle-discount]').textContent = percent ? host.dataset.discountText.replace('__PERCENT__',percent) : '';
        host.querySelector('[data-nh-bundle-saving]').textContent = percent ? host.dataset.savingText.replace('__AMOUNT__',money(subtotal-total)) : '';
        host.querySelector('[data-nh-bundle-total]').textContent = money(total);
        const previous = host.querySelector('[data-nh-bundle-subtotal]');
        previous.textContent = money(subtotal);
        previous.hidden = !percent;
        host.querySelectorAll('[data-nh-bundle-tier]').forEach(tier => tier.classList.toggle('is-active', Number(tier.dataset.nhBundleTier) === count));
        submit.disabled = busy || added || count < 2 || count > 3;
        submit.textContent = busy ? host.dataset.loadingText : count < 2 ? host.dataset.minimumText : host.dataset.submitText;
      };
      const reset = () => {
        added = false;
        message.hidden = true;
        cartLink.hidden = true;
        submit.hidden = false;
        items.forEach(item => {item.quantity = item.id === host.dataset.currentVariant && item.available ? 1 : 0;});
        update();
      };
      reset();
      document.querySelectorAll('.nh-pilot-combine a, [data-nh-bottom-bundle]').forEach(link => {
        link.setAttribute('aria-haspopup','dialog');
        link.setAttribute('aria-controls',dialog.id);
        link.addEventListener('click', event => {
          event.preventDefault();
          opener = link;
          if (added) reset();
          host.querySelectorAll('.nh-bundle__product img').forEach(image => {image.loading = 'eager';});
          dialog.showModal();
        });
      });
      host.querySelector('[data-nh-bundle-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click',event => {if (event.target === dialog) dialog.close();});
      items.forEach(item => {
        item.row.querySelector('[data-nh-bundle-more]').addEventListener('click', () => {
          if (busy || !item.available || calculate().count >= 3) return;
          item.quantity += 1; update();
        });
        item.row.querySelector('[data-nh-bundle-less]').addEventListener('click', () => {
          if (busy) return;
          item.quantity = Math.max(0,item.quantity-1); update();
        });
      });
      submit.addEventListener('click', async () => {
        const {count,percent} = calculate();
        if (busy || added || count < 2 || count > 3) return;
        busy = true; message.hidden = true; update();
        const drawer = document.querySelector('cart-drawer');
        const sections = drawer?.getSectionsToRender().map(section => section.id) || ['cart-icon-bubble'];
        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`,{
            method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},
            body:JSON.stringify({items:items.filter(item => item.quantity > 0).map(item => ({id:Number(item.id),quantity:item.quantity,properties:{'_Bundle-Typ':'Freie Produktauswahl','_Bundle-Staffel':`${count} Produkte / ${percent} %`}})),sections,sections_url:window.location.pathname})
          });
          const data = await response.json();
          if (!response.ok || data.status) throw new Error(typeof data.description === 'string' ? data.description : host.dataset.errorText);
          added = true;
          if (drawer && sections.every(id => data.sections?.[id])) {
            dialog.close();
            drawer.classList.remove('is-empty');
            drawer.setActiveElement(opener);
            drawer.renderContents(data);
          } else {
            message.textContent = host.dataset.addedText;
            message.hidden = false; submit.hidden = true; cartLink.hidden = false;
          }
          if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'nh-pilot-bundle',cartData:data});
        } catch (error) {
          message.textContent = added ? host.dataset.addedText : error.message || host.dataset.errorText;
          message.hidden = false;
          if (added) {submit.hidden = true; cartLink.hidden = false; if (!dialog.open) dialog.showModal();}
        } finally {busy = false; update();}
      });
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(),{once:true});
    else initialize();
    document.addEventListener('shopify:section:load',event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["nh-pilot-pack-selector"] && !Shopify.designMode) return;
  try {
    (() => {
    const initialize = (root = document) => {
      root.querySelectorAll('[data-nh-pilot-packs]').forEach((selector) => {
        if (selector.dataset.initialized === 'true') return;
        const form = document.getElementById(selector.dataset.productFormId);
        const quantity = selector.querySelector('[data-nh-pilot-quantity]');
        const choices = Array.from(selector.querySelectorAll('[data-nh-pilot-choice]'));
        const submitLabel = form?.querySelector('.product-form__submit > span:not(.loading__spinner)');
        if (!form || !quantity || !choices.length) return;
        selector.dataset.initialized = 'true';
        const sync = (choice, broadcast = true) => {
          choice.checked = true;
          quantity.value = choice.value;
          quantity.dispatchEvent(new Event('change', {bubbles:true}));
          const fields = {price:'price',compare:'compare',daily:'daily',unit:'unit',label:'selectedLabel',shipping:'shipping'};
          Object.entries(fields).forEach(([target,source]) => {
            const element = selector.querySelector(`[data-nh-selected-${target}]`);
            if (element) element.textContent = choice.dataset[source];
          });
          const compare = selector.querySelector('[data-nh-selected-compare]');
          if (compare) compare.hidden = choice.dataset.showCompare !== 'true';
          if (submitLabel && !form.querySelector('.product-form__submit')?.disabled) submitLabel.textContent = choice.dataset.cta;
          if (broadcast) document.dispatchEvent(new CustomEvent('nh:pack-change', {detail:{productId:selector.dataset.productId, value:choice.value, source:selector}}));
        };
        choices.forEach(choice => choice.addEventListener('change',() => sync(choice)));
        const peer = [...document.querySelectorAll('[data-nh-pilot-packs]')].find(el => el !== selector && el.dataset.productId === selector.dataset.productId && el.dataset.initialized === 'true');
        const current = peer?.querySelector('[data-nh-pilot-choice]:checked')?.value;
        const onSync = event => {
          if (event.detail.source === selector || event.detail.productId !== selector.dataset.productId) return;
          const choice = choices.find(item => item.value === event.detail.value);
          if (choice) sync(choice, false);
        };
        document.addEventListener('nh:pack-change', onSync);
        const onUnload = event => { if (event.target.contains(selector)) { document.removeEventListener('nh:pack-change',onSync); document.removeEventListener('shopify:section:unload',onUnload); } };
        document.addEventListener('shopify:section:unload',onUnload);
        sync(choices.find(choice => choice.value === current) || choices.find(choice => choice.checked) || choices[0], false);
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',() => initialize(),{once:true});
    else initialize();
    document.addEventListener('shopify:section:load',event => initialize(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
